import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const rowCardLiteDefaultVariants = {}
const rowCardLiteCompoundVariants = []

const rowCardLiteSlotNames = [
  [
    "root",
    "row-card-lite__root"
  ],
  [
    "contentWrapper",
    "row-card-lite__contentWrapper"
  ],
  [
    "imageWrapper",
    "row-card-lite__imageWrapper"
  ],
  [
    "image",
    "row-card-lite__image"
  ],
  [
    "title",
    "row-card-lite__title"
  ]
]
const rowCardLiteSlotFns = /* @__PURE__ */ rowCardLiteSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, rowCardLiteDefaultVariants, getSlotCompoundVariant(rowCardLiteCompoundVariants, slotName))])

const rowCardLiteFn = memo((props = {}) => {
  return Object.fromEntries(rowCardLiteSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const rowCardLiteVariantKeys = []
const getVariantProps = (variants) => ({ ...rowCardLiteDefaultVariants, ...compact(variants) })

export const rowCardLite = /* @__PURE__ */ Object.assign(rowCardLiteFn, {
  __recipe__: false,
  __name__: 'rowCardLite',
  raw: (props) => props,
  variantKeys: rowCardLiteVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, rowCardLiteVariantKeys)
  },
  getVariantProps
})